import React, { useEffect } from "react";
import './style.css'
import BranchDetailsInfoContainer from "../../../components/DashboardComponents/BranchDetailsInfoContainer/BranchDetailsInfoContainer";

const ManagePurchases = ({setActivePath}) => {
    useEffect(() => {
        setActivePath("Manage Purchases");
      }, [setActivePath]);


  return (
    <div className="outlet-container">
       <BranchDetailsInfoContainer paddingRequired actionRequired actionName="Add Categories"/>
       <BranchDetailsInfoContainer paddingRequired actionRequired actionName="Add Products"/>
       <BranchDetailsInfoContainer paddingRequired actionName="Add Categories"/>
       <BranchDetailsInfoContainer paddingRequired actionName="Add Products"/>

       <BranchDetailsInfoContainer />

      
    </div>
  )
}

export default ManagePurchases
